import { IDashboardBusinessControlsGetDTO, IDashboardBusinessControlsViewDTO, IDashboardBusinessControlGetStatusDTO } from './../../coreapi-dto/accounting/dashboardBusinessControl';
import { IRequestEventHandler, CoreApiResponse } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { ContentType } from '../../fetchApiDistributor/contentTypes';
import BaseCoreApiRequest from "../baseCoreApiRequest";


class DashboardBusinessControlsRequest extends BaseCoreApiRequest {

    protected _routePrefix: string
    protected _eventHandler: IRequestEventHandler;
    protected readonly _token: string

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl)
        this._routePrefix = 'Dashboard'
        this._eventHandler = eventHandler
        this._token = token
    }
    getView(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IDashboardBusinessControlsViewDTO>>) => void) {
        const startTime = new Date().getTime();
        this.post<IViewWrapper<IDashboardBusinessControlsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/view`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    getViewById(idGlobal: string, callback?: (e: CoreApiResponse<IDashboardBusinessControlsGetDTO>) => void) {
        this.get<IDashboardBusinessControlsGetDTO>(`${this._baseUrl}/${this._routePrefix}/${idGlobal}/`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    sync(callback?: (e: CoreApiResponse<null>) => void) {
        super.post2<null>(`${this._baseUrl}/${this._routePrefix}/sync`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                callback?.(e)
            },
        );
    }

    status(callback?: (e: CoreApiResponse<IDashboardBusinessControlGetStatusDTO>) => void) {
        super.get<IDashboardBusinessControlGetStatusDTO>(`${this._baseUrl}/${this._routePrefix}/status`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]),
            (e) => {
                callback?.(e);
            },
        );
    }
}

export default DashboardBusinessControlsRequest